<nb-list class="popup-list">
    <nb-list-item (click)="selectItem(option)" class="navigation-option" *ngFor="let option of options; let i = index">
        <div class="option-index">
            <span>{{ i + 1 }}</span>
        </div>
        <div class="option-label ellipsis">{{ option.label }}</div>
    </nb-list-item>
</nb-list>
